import { useState } from 'react';
import { Modal, Input } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

export default function ModalRechazarReembolso({ visible, onClose, onConfirm, loading }) {
  const [motivoRechazo, setMotivoRechazo] = useState('');

  const handleOk = () => {
    if (motivoRechazo.trim()) {
      onConfirm(motivoRechazo);
    }
  };

  const handleCancel = () => {
    setMotivoRechazo('');
    onClose();
  };

  return (
    <Modal
      title={
        <span>
          <CloseCircleOutlined style={{ marginRight: 8 }} />
          Rechazar Reembolso
        </span>
      }
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Rechazar"
      cancelText="Cancelar"
      okButtonProps={{ disabled: !motivoRechazo.trim(), danger: true }}
      className="pagos-v2-modal"
    >
      <p>Escribe el motivo por el cual se rechaza este reembolso:</p>
      <Input.TextArea
        rows={3}
        value={motivoRechazo}
        onChange={(e) => setMotivoRechazo(e.target.value)}
        placeholder="Motivo de rechazo..."
      />
    </Modal>
  );
}
